export default __webpack_public_path__ + "static/media/brand-main-sm.3c869bcf.png";